import {guideSvg as Icon__small__guideSvg} from '../Icon__small/Icon__small--guide.js'

export var guide = {
  name: 'guide',
  category: 'icon',
  colorable: true,
  svg: Icon__small__guideSvg,
};
